import { useRouter } from 'next/router'
import React from 'react'
import ga from 'src/utils/pixels/gtag'

type Props = {
  /** When the toggle sits on a dark surface, flip text colors for contrast. */
  darkSurface?: boolean
}

const LanguageToggle = ({ darkSurface = false }: Props) => {
  const router = useRouter()
  const { locale, pathname, query, asPath } = router
  const isEs = locale === 'es'

  const switchLocale = (newLocale: string) => {
    if (newLocale === locale) return
    // Fires only on a real change (the early return above filters no-op taps),
    // so the count is "deliberate locale switches", not toggle renders.
    ga.event('locale_switch', {
      from: locale ?? 'es',
      to: newLocale,
      surface: pathname
    })
    router.push({ pathname, query }, asPath, { locale: newLocale })
  }

  const activeClass = darkSurface
    ? 'font-semibold text-white-500'
    : 'font-semibold text-ink-700'
  const inactiveClass = darkSurface
    ? 'text-cream-300 hover:text-white-500'
    : 'text-ink-400 hover:text-ink-700'
  const dividerClass = darkSurface ? 'text-white-500/40' : 'text-ink-200'

  return (
    <div className="flex items-center gap-1 text-sm">
      <button
        type="button"
        onClick={() => switchLocale('es')}
        className={`rounded px-1.5 py-0.5 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 ${
          isEs ? activeClass : inactiveClass
        }`}
      >
        ES
      </button>
      <span className={dividerClass}>|</span>
      <button
        type="button"
        onClick={() => switchLocale('en')}
        className={`rounded px-1.5 py-0.5 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 ${
          !isEs ? activeClass : inactiveClass
        }`}
      >
        EN
      </button>
    </div>
  )
}

export default React.memo(LanguageToggle)
